import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { auditLogApiUrl } from '@/config/audit-log';
import { appendPageable, readPagedRows } from '../utils/spring-api';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const apiUrl = () => auditLogApiUrl('/audit-log/api/audit-logs');
const initialState = {
    loading: false,
    errorMessage: null,
    logs: [],
    totalItems: 0,
};
function appendQueryParam(q, key, value) {
    const trimmed = value?.trim();
    if (trimmed) {
        q.set(key, trimmed);
    }
}
function buildAuditLogParams({ page, size, sort, username, activity, startDate, endDate, searchText, }) {
    const q = new URLSearchParams();
    appendPageable(q, page, size, sort);
    appendQueryParam(q, 'username', username);
    appendQueryParam(q, 'activity', activity);
    appendQueryParam(q, 'startDate', startDate);
    appendQueryParam(q, 'endDate', endDate);
    appendQueryParam(q, 'searchText', searchText);
    return q;
}
export async function fetchAuditLogRows(params) {
    const q = buildAuditLogParams(params);
    const response = await axios.get(`${apiUrl()}?${q.toString()}`);
    return readPagedRows(response.data, response.headers);
}
export const getAuditLogs = createAsyncThunk('audit-Log/fetch', async (params) => fetchAuditLogRows(params), { serializeError: serializeAxiosError });
export const AuditLogSlice = createSlice({
    name: 'auditLog',
    initialState: initialState,
    reducers: {
        reset() {
            return initialState;
        },
        clearErrorMessage(state) {
            state.errorMessage = null;
        },
    },
    extraReducers(builder) {
        builder
            .addMatcher(isFulfilled(getAuditLogs), (state, action) => {
            state.loading = false;
            state.logs = action.payload.rows;
            state.totalItems = action.payload.total;
        })
            .addMatcher(isPending(getAuditLogs), (state) => {
            state.errorMessage = null;
            state.loading = true;
        })
            .addMatcher(isRejected(getAuditLogs), (state, action) => {
            state.loading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { reset, clearErrorMessage } = AuditLogSlice.actions;
export default AuditLogSlice.reducer;
